<template>
  <div id="main">
    <div class="e10-video">
      <video src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/home_e10.mp4"
             @contextmenu.prevent
             :poster="require('@/assets/img/home/e10-cover.png')"
             autoplay muted loop playsinline preload="auto"
             x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"></video>
      <div class="content">
        <p>盆底元气蛋</p>
        <p>E10 series 盆底康复治疗仪</p>
        <div class="home-btn white" @click="goProduct('e10')">新品上市，探索更多</div>
        <div class="copyright">广告审查批准文号:苏械广审(视)第270213-02323号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043  盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
    </div>
    <div class="t20-video">
      <video src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/home_t20.mp4"
             @contextmenu.prevent
             :poster="require('@/assets/img/home/t20-cover.png')"
             autoplay muted loop playsinline preload="auto"
             x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"></video>
      <div class="content">
        <p>精准治疗，紧致升级</p>
        <p>澜渟 T20 series 盆底康复治疗仪</p>
        <div class="home-btn white" @click="goProduct('t20')">了解更多</div>
        <div class="copyright">广告审查批准文号:苏械广审(视)第260322-05152号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
    </div>
    <div class="swiper-content">
      <div id="productSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(posterItem, posterIndex) in productPoster" :key="posterIndex"
               @click="posterItem.event">
            <div class="img-container">
              <img :src="posterItem.path" alt="" />
            </div>
            <p class="title">{{ posterItem.title }}</p>
            <p class="desc">{{ posterItem.desc }}</p>
            <div class="words" v-html="posterItem.words"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-content">
      <div class="content">
        <p>澜渟智能服务平台</p>
        <p>家用盆底康复软件</p>
        <div class="home-btn black" @click="goApp">了解更多</div>
        <p>两大盆底 App</p>
        <p>助力盆底康复行业智慧化升级</p>
      </div>
      <div id="appSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(appItem, appIndex) in appSwiperList" :key="appIndex">
            <div class="img-container">
              <img :src="appItem.path" alt="" />
            </div>
            <p class="title">{{ appItem.title }}</p>
            <p class="desc">{{ appItem.desc }}</p>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="about-content">
      <img v-lazy="require('@/assets/img/home/about.png')" alt="">
      <div class="content">
        <p>关于澜渟</p>
        <p>专研家用盆底医学品牌</p>
        <div class="home-btn white" @click="goAbout('info')">了解更多</div>
      </div>
    </div>
    <div class="more-content">
      <p>更多信息</p>
      <div class="content">
        <p>核心技术</p>
        <div class="home-btn black-outline" @click="goTech">了解更多</div>
        <img v-lazy="require('@/assets/img/home/tech.png')" alt="">
      </div>
      <div class="content">
        <p>新闻中心</p>
        <div class="home-btn black-outline" @click="goAbout('consultation')">了解更多</div>
        <img v-lazy="require('@/assets/img/home/news.png')" alt="">
      </div>
      <div class="content">
        <p>联系我们</p>
        <div class="home-btn black-outline" @click="goAbout('concat')">了解更多</div>
        <img v-lazy="require('@/assets/img/home/concat.png')" alt="">
      </div>
    </div>
    <div class="shop-lt">
      <img v-lazy="require('@/assets/img/home/lt-shop.png')" alt="">
      <div class="content">
        <p>澜渟品牌店铺</p>
        <div class="btn-list">
          <div class="home-btn white" @click="openUrl('https://mall.jd.com/index-1000303621.html')">
            <img alt :src="require('@/assets/img/home/mall-jd.png')" />
            京东
          </div>
          <div class="home-btn white" @click="openUrl('https://lanting.tmall.com/')">
            <img alt :src="require('@/assets/img/home/mall-tmall.png')" />
            天猫
          </div>
          <div class="home-btn white"
               @click="openUrl('https://www.douyin.com/user/MS4wLjABAAAAygVxn6nKRVHFNr3cmNjeHui-HLuc2AKUewfldBd4iOyyQCHzlPlfh66oFejjkaG6')">
            <img alt :src="require('@/assets/img/home/mall-tiktok.png')" />
            抖音
          </div>
        </div>
      </div>
    </div>
    <div class="phone">
      <img v-lazy="require('@/assets/img/home/tel.png')" alt="">
      <div class="content">
        <p>线下经销商合作</p>
        <div class="home-btn white" @click="goPhone('17372217350')">
          <img alt :src="require('@/assets/img/home/phone.png')" />
          招商电话：17372217350
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      productSwiper: null,
      appSwiper: null,
      productPoster: [
        {
          path: require('@/assets/img/home/product-poster-7.png'),
          title: 'H30 series 盆底康复治疗仪',
          desc: '「盆底+私密」诊疗一体机',
          words: '广告审查批准文号:苏械广审(文)第270731-17967号<br/>盆底康复治疗仪 医器械注册号:苏械注准20252091406<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用<br/>禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司',
          event: () => {
            this.goProduct('h30');
          },
        },
        {
          path: require("@/assets/img/home/product-poster-3.png"),
          title: "E10 series 盆底康复治疗仪",
          desc: "双重修复 科学治疗",
          words: '广告审查批准文号:苏械广审(文)第270516-11344号<br/>盆底康复治疗仪 医器械注册号:苏械注准20252090043<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用<br/>禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司',
          event: () => {
            this.goProduct("e10");
          }
        },
        {
          path: require("@/assets/img/home/product-poster-4.png"),
          title: "T20 series 盆底康复治疗仪",
          desc: "双重修复，紧致系统",
          words: '广告审查批准文号:苏械广审(文)第260411-06435号<br/>盆底康复治疗仪 医器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用<br/>禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司',
          event: () => {
            this.goProduct("t20");
          }
        },
        {
          path: require("@/assets/img/home/product-poster-5.png"),
          title: "初澜盆底生物刺激反馈仪",
          desc: "",
          words: "",
          event: () => {}
        },
        {
          path: require("@/assets/img/home/product-poster-6.png"),
          title: "T20 Max 盆底肌修复仪",
          desc: "盆底抗衰一体机",
          words: "",
          event: () => {
            this.goProduct("wrightinTwo");
          }
        },
        {
          path: require("@/assets/img/home/product-poster-1.png"),
          title: "盆底肌肉康复器",
          desc: "锻炼盆底 提升肌力",
          words: '广告审查批准文号:苏械广审(文)第281223-24299号<br/>盆底肌肉康复器 一类医疗器械备案号:苏宁械备20180019号<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用<br/>禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司',
          event: () => {
            this.goProduct("kegel");
          }
        },
        {
          path: require("@/assets/img/home/product-poster-2.png"),
          title: "洛澜盆底康复治疗仪",
          desc: "多功能产后治疗一体机",
          words: '广告审查批准文号:苏械广审(文)第270819-19796号<br/>盆底康复治疗仪 医疗器械注册证编号:苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用<br/>禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司',
          event: () => {
            this.goProduct("luolan");
          }
        },
      ],
      appSwiperList: [
        {
          path: require("@/assets/img/home/app-lt.png"),
          title: "澜渟用户版",
          desc: "医生进阶学习"
        },
        {
          path: require("@/assets/img/home/app-ltd.png"),
          title: "澜渟医生版",
          desc: "双重修复，紧致系统"
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.productSwiper = new Swiper("#productSwiper", {
      loop: true, // 循环模式
      width: document.querySelector(".img-container").clientWidth,
      spaceBetween: this.rem,
      pagination: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.appSwiper = new Swiper("#appSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
  methods: {
    goPhone(phone) {
      window.location.href = `tel:${phone}`;
    },

    goProduct(route) {
      this.$router.push({ path: "/product/" + route });
    },

    goApp() {
      this.$router.push({ path: "/app" });
    },

    goAbout(route) {
      this.$router.push({ path: "/about/" + route });
    },

    goTech() {
      this.$router.push({ path: "/technology" });
    },

    openUrl(url) {
      window.open(url);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #fff;
}

.home-btn {
  padding: 0.6rem 2rem;
  border-radius: 3.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;

  &.white {
    background-color: #fff;
    color: #000;
  }

  &.black {
    background-color: #000;
    color: #fff;
  }

  &.black-outline {
    border: 0.1rem solid #000;
    color: #000;
  }
}

.e10-video,
.t20-video {
  position: relative;
  height: 66.7rem;
  width: 37.5rem;

  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    z-index: 1;
  }

  > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 46.1rem;

    > p {
      z-index: 2;
      color: #fff;
      font-size: 1.8rem;
      text-align: center;
      line-height: 2.5rem;
      font-weight: 500;

      &:first-child {
        margin-bottom: 0.4rem;
      }
    }

    > .home-btn {
      z-index: 2;
      margin-top: 2rem;
    }

    >.copyright {
      position: absolute;
      bottom: 1.2rem;
      left: 0;
      width: 100%;
      padding: 0 2%;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.2rem;
      pointer-events: none;
      z-index: 2;
    }
  }
}

.swiper-content {
  width: 100%;
  overflow: hidden;
  height: 55rem;

  > #productSwiper {
    width: 100%;
    height: 100%;
    position: relative;
    margin-left: 3.8rem;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 27.9rem;
        height: 55rem;
        overflow: hidden;
        position: absolute;

        > img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }

      > .title {
        position: absolute;
        top: 4.8rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.8rem;
        color: #000000;
        line-height: 2.5rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        top: 7.7rem;
        width: 100%;
        font-size: 1.3rem;
        color: #666666;
        line-height: 1.8rem;
        text-align: center;
      }

      >.words {
        position: absolute;
        bottom: 1.2rem;
        left: 0;
        width: 100%;
        padding: 0 1.2rem;
        font-weight: 400;
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.6);
        line-height: 1.2rem;
        pointer-events: none;
        text-align: left;
      }
    }
  }
}

.app-content {
  width: 100%;
  overflow: hidden;

  > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4.8rem;

    > p:nth-child(1) {
      font-weight: 500;
      font-size: 1.8rem;
      color: #000000;
      line-height: 2.5rem;
    }

    > p:nth-child(2) {
      font-weight: 500;
      font-size: 1.4rem;
      color: #000000;
      line-height: 2rem;
      margin-top: 0.4rem;
    }

    > .home-btn {
      margin-top: 2rem;
    }

    > p:nth-child(4) {
      font-weight: 500;
      font-size: 1.4rem;
      color: #000000;
      line-height: 2rem;
      margin-top: 2.8rem;
    }

    > p:nth-child(5) {
      font-size: 1.4rem;
      color: #999;
      line-height: 2rem;
      margin-top: 0.4rem;
    }
  }

  > #appSwiper {
    margin-top: 3rem;
    width: 100%;
    height: 41.6rem;
    position: relative;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;

        > img {
          margin-left: 2rem;
          width: 33.5rem;
        }
      }

      > .title {
        position: absolute;
        top: 2rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        top: 4.4rem;
        width: 100%;
        font-size: 1.2rem;
        color: #999999;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    .swiper-pagination {
      bottom: 2rem;
      text-align: right;
      padding-right: 3.6rem;
    }

    /deep/.swiper-pagination-bullet {
      margin: 0 0.6rem;
    }

    /deep/.swiper-pagination-bullet-active {
      background: transparent;
      border: 0.1rem solid rgba(0, 0, 0, 0.2);
    }
  }
}

.about-content {
  position: relative;
  display: flex;
  justify-content: center;

  > img {
    width: 100%;
  }

  > .content {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4.8rem;

    > p:nth-child(1) {
      font-weight: 500;
      font-size: 1.8rem;
      color: #fff;
      line-height: 2.5rem;
    }

    > p:nth-child(2) {
      font-weight: 500;
      font-size: 1.4rem;
      color: #fff;
      line-height: 2rem;
      margin-top: 0.4rem;
    }

    > .home-btn {
      margin-top: 2rem;
    }
  }
}

.more-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.6rem;

  > p {
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    padding: 4rem 0;
  }

  > .content {
    border-radius: 2rem;
    width: 100%;
    height: 40rem;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.2rem;

    &:nth-child(2) {
      height: 45.8rem;
    }

    > p {
      font-weight: 500;
      font-size: 1.8rem;
      color: #000000;
      line-height: 2.5rem;
      margin-top: 4.3rem;
      z-index: 2;
    }

    > .home-btn {
      margin-top: 2rem;
      z-index: 2;
    }

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      z-index: 1;
    }
  }
}

.shop-lt,
.shop-mulan {
  padding-top: 1.2rem;
  position: relative;
  height: 53.6rem;

  > img {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  > .content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 11.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: rgba(250, 251, 254, 0.1);
    backdrop-filter: blur(2rem);
    padding: 2.4rem 3.2rem;

    > p {
      font-weight: 500;
      font-size: 1.8rem;
      color: #FFFFFF;
      line-height: 2.5rem;
    }

    > .btn-list {
      display: flex;
      justify-content: space-between;
      width: 100%;

      > .home-btn {
        > img {
          width: 1.6rem;
          margin-right: 0.4rem;
          filter: brightness(0);
        }
      }
    }
  }
}

.phone {
  margin-top: 1.2rem;
  position: relative;
  height: 37.7rem;

  > img {
    width: 100%;
    position: absolute;
  }

  > .content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 11.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: rgba(250, 251, 254, 0.1);
    backdrop-filter: blur(2rem);
    padding: 2.4rem 3.2rem;

    > p {
      font-weight: 500;
      font-size: 1.8rem;
      color: #FFFFFF;
      line-height: 2.5rem;
    }

    > .home-btn {
      > img {
        width: 1.6rem;
        margin-right: 0.4rem;
        filter: brightness(0);
      }
    }
  }
}
</style>
